import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from './shared/entities/language';

@Component({
  selector: 'app-root',
  template: `<simple-notifications [options]="options"></simple-notifications><router-outlet></router-outlet>`
})
export class AppComponent {

  public options = {
    position: ['top', 'right'],
    timeOut: 5000,
    lastOnBottom: true
  };

  constructor(translateService: TranslateService) {
      const langs: string[] = [];
      Languages.forEach(l => langs.push(l.Culture));
      const browserLang: string = translateService.getBrowserLang().toLowerCase();
      const defaultLanguage: string = langs.indexOf(browserLang) >= 0 ? browserLang : langs[0];
      translateService.setDefaultLang(defaultLanguage);
      translateService.use(defaultLanguage);
  }

}



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/app/app.component.ts